// Preload some common vendor libraries that will be used on all components
// Doing this all in one module will hint to webpack to group most of these together.
import $ from 'jquery' // Needed to be loaded by kendo before angular.

// Vendor angular modules.
import 'angular'
import "angular-animate"
import "angular-aria"
import "angular-messages"
import "angular-sanitize"

// Moment, which we use in order to perform date parsing/formatting
import 'moment'
import 'moment-duration-format' // Patches the requireable moment object.
import "angular-moment"

// Misc third-party angular extensions.
import "angular-file-model"
import "ng-file-upload"
import "angular-ui-router"
import "oclazyload"
import "qrcode-generator"
import "qrcode-generator/qrcode_UTF8"

// datejs is used in some places for the augmented date.toString and Date.parse.
//TODO: Consolidate to use moment in all cases so we don't need to import a second date library.
import 'datejs'

// Pick only the kendo components that we are using.
import 'kendo-ui-core/js/kendo.core'
import 'kendo-ui-core/js/kendo.autocomplete'
import 'kendo-ui-core/js/kendo.calendar'
import 'kendo-ui-core/js/kendo.combobox'
import 'kendo-ui-core/js/kendo.datepicker'
import 'kendo-ui-core/js/kendo.dropdownlist'
import 'kendo-ui-core/js/kendo.multiselect'
import 'kendo-ui-core/js/kendo.numerictextbox'
import 'kendo-ui-core/js/kendo.popup'
import 'kendo-ui-core/js/kendo.timepicker'
import 'kendo-ui-core/js/kendo.angular'

import "@sentry/browser";
import "@sentry/integrations";

// Import some Winxnet core utilities that are exposed on the window.
import WinxnetUtility from '../vendor/WinxnetCommon/Winxnet.Utility';

// Need to keep this for now
($ as any).utility = new WinxnetUtility((window as any).baseUrl, (window as any).apiUrl);
(window as any).utility = ($ as any).utility;

// Import common angularjs functionality (utility service, etc)
import '../vendor/WinxnetCommon/Winxnet.Directives'

// Create a utility function on $ to display a styled alert box.
import '../vendor/WinxnetCommon/Winxnet.UI.ConfirmWindow'

// Import vendor CSS and resources.
import "@progress/kendo-theme-bootstrap/dist/all.css";
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.css"

// Add third party library for charts
import 'chart.js';
import 'angular-chart.js';
import 'chartjs-plugin-labels';
